import React, { useEffect, useState } from 'react'
import { Grid, Typography, Box } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import CardList from './cardList'
import Card from '../../components/CommonComponents/Card'
import { PatientStore } from '../../stores'
import { IoIosArrowBack } from 'react-icons/io'
import {
  BOOKING_STATUS,
  VISIT_TYPE,
  LIST_TYPE,
  NETWORK_STATUS
} from '../../Constants'
import Loading from 'react-loading'
import PatientCards from './PatientCard'
import { Link } from 'react-router-dom'

const PatientInsights = () => {
  const classes = useStyles()
  const { upcomingdata, networkStatus } = PatientStore.useStoreState(state => ({
    ...state.appointments
  }))
  const { getList } = PatientStore.useStoreActions(actions => ({
    ...actions.appointments
  }))

  useEffect(() => {
    getList({
      list_type: LIST_TYPE.UPCOMING.label,
      status: BOOKING_STATUS.ALL.value,
      visit_type: VISIT_TYPE.ALL.id,
      appointment_type: '0',
      sorting: {
        appointment_date: 'ASC',
        start_time: 'ASC'
      }
    })
  }, [])

  return (
    <Grid container spacing={3} className={classes.dashboardRoot}>
      <Grid item sm={12} className={classes.insights}>
        {/* Dashboard */}
        <Grid container spacing={3}>
          <Grid item sm={12} className={classes.upcomingAppointmentsRoot}>
            {/* Day Board */}
            <Link to="/patient/selectPatient" className={classes.navLink}>
              <button className={classes.Backbtn}>
                <IoIosArrowBack className={classes.Backicon} />
                Select Patient Account
              </button>
            </Link>
            <div className={classes.upcomingAppointments}>
              <Card
                style={{ minHeight: '340px', borderTop: '4px solid #535f8f' }}>
                <h4> Upcoming Appointments</h4>
                {/* <DashboardAppointments /> */}
                {networkStatus === NETWORK_STATUS.FETCHING ? (
                  <Loading
                    type="cylon"
                    textAlign="center"
                    color="grey"
                    height={40}
                  />
                ) : upcomingdata.length ? (
                  upcomingdata.length > 5 ? (
                    <React.Fragment>
                      <PatientCards appointments={upcomingdata.slice(0, 5)} />

                      <Link
                        to="/patient/appointments"
                        className={classes.navLink}>
                        View More...
                      </Link>
                    </React.Fragment>
                  ) : (
                    <PatientCards appointments={upcomingdata} />
                  )
                ) : (
                  <p>Nothing Found</p>
                )}
              </Card>
            </div>
          </Grid>
          <Grid item sm={3} className={classes.AppointmentsCard}>
            <CardList linkType={1} />
          </Grid>
          <Grid item sm={3} className={classes.AppointmentsCard}>
            {/* Day Status */}
            <CardList linkType={2} />
          </Grid>
          <Grid item sm={3} className={classes.AppointmentsCard}>
            {/* Day Status */}
            <CardList linkType={3} />
          </Grid>
          <Grid item sm={3} className={classes.AppointmentsCard}>
            {/* Day Status */}
            <CardList linkType={4} />
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  )
}

const useStyles = makeStyles(() => ({
  dashboardRoot: {
    margin: '12px 0',
    width: '100%',
    justifyContent: 'flex-start',
    '@media (max-width:991px)': {
      margin: '0px 0 10px',
      paddingRight: '15px'
    },
    '@media (max-width:550px)': {
      margin: '10px 0 10px',
      paddingRight: '15px'
    }
  },
  Backbtn: {
    marginRight: '20px',
    background: 'none',
    border: '0px',
    fontSize: '16px',
    display: 'flex',
    alignItems: 'center',
    color: '#333',
    cursor: 'pointer',
    marginTop: '-25px',
    marginBottom: '0',
    '@media (max-width:550px)': {
      marginBottom: '0px'
    }
  },
  Backicon: {
    marginRight: '5px'
  },
  insights: {
    '@media (max-width:991px)': {
      maxWidth: '100%',
      flexBasis: '100%'
    }
  },
  HospitalList: {
    display: 'flex',
    flexDirection: 'column',
    '@media (max-width:991px)': {
      flexDirection: 'row',
      flexWrap: 'wrap'
    },
    '& img': {
      width: '100%',
      marginBottom: '15px'
    }
  },
  HospitalImg: {
    '& img': {
      width: '100%'
    },
    '@media (max-width:991px)': {
      width: '25%'
    },
    '@media (max-width:550px)': {
      width: '50%'
    }
  },
  // insights: {
  //   maxWidth: 950
  // },
  // upcomingAppointmentsRoot: {
  //   maxWidth: 750
  // },
  upcomingAppointmentsRoot: {
    '@media (max-width:767px)': {
      maxWidth: '100%',
      flexBasis: '100%'
    }
  },
  AppointmentsCard: {
    '@media (max-width:767px)': {
      maxWidth: '100%',
      flexBasis: '100%'
    }
  },
  upcomingAppointments: {
    maxWidth: '100%',
    minHeight: 375,
    '& h4': {
      marginTop: '0px',
      fontWeight: '500',
      color: '#111d4e',
      display: 'flex'
    }
  },
  myHospital: {
    width: '100%',
    marginBottom: 16,
    '& h2': {
      fontSize: '24px',
      fontWeight: '500'
    },
    '& img': {
      width: '100%'
    },
    '&>p': {
      fontSize: '14px',
      fontWeight: '400'
    },
    '&>img': {
      width: '100%'
    }
  },
  news: {
    // maxWidth: 'unset'
    '@media (max-width:991px)': {
      maxWidth: '100%',
      flexBasis: '100%'
    }
  },
  NoticeList: {
    width: '100%',
    borderBottom: '1px rgba(0,0,0,0.1) solid',
    '& h3': {
      fontSize: '18px',
      marginBottom: '0px',
      color: 'rgba(0,0,0,0.8)'
    },
    '& p': {
      fontSize: '14px',
      color: 'rgba(0,0,0,0.6)',
      marginTop: '0px'
    },
    '& h6': {
      fontSize: '11px',
      color: 'rgba(0,0,0,0.5)',
      marginTop: '0px'
    }
  },
  embeddedTwitter: {
    display: 'none'
  },
  show: {
    display: 'block'
  }
}))

export default PatientInsights
